import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function LockIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M22 11H10V9.75a6.13 6.13 0 0 1 6-6.25c2.18 0 4.2 1.24 5.25 3.23.32.6 1.05.82 1.63.48.58-.33.8-1.1.47-1.7A8.23 8.23 0 0 0 11.93 2.1 8.81 8.81 0 0 0 7.6 9.75v1.78A6.26 6.26 0 0 0 4 17.25v7.5A6.14 6.14 0 0 0 10 31h12c3.31 0 6-2.8 6-6.25v-7.5A6.14 6.14 0 0 0 22 11Zm-4.8 11.25c0 .7-.54 1.25-1.2 1.25-.66 0-1.2-.56-1.2-1.25v-2.5c0-.69.54-1.25 1.2-1.25.66 0 1.2.56 1.2 1.25v2.5Z"
      />
      <path
        fill="currentColor"
        d="M10 11h12V9.75a6.13 6.13 0 0 0-6-6.25 5.97 5.97 0 0 0-5.25 3.23c-.32.6-1.05.82-1.63.48a1.28 1.28 0 0 1-.47-1.7A8.23 8.23 0 0 1 20.07 2.1a8.81 8.81 0 0 1 4.33 7.65v1.78c2.18 1 3.6 3.24 3.6 5.72v7.5A6.14 6.14 0 0 1 22 31H10c-3.31 0-6-2.8-6-6.25v-7.5A6.14 6.14 0 0 1 10 11Zm4.8 11.25c0 .7.54 1.25 1.2 1.25.66 0 1.2-.56 1.2-1.25v-2.5c0-.69-.54-1.25-1.2-1.25-.66 0-1.2.56-1.2 1.25v2.5Z"
      />
    </BaseIcon>
  );
}
